import { Dispatch } from 'redux';
import ConnectedPageController from '../../controllers/ConnectedPageController';
import { StoreState } from '../../store-interfaces';
import onboardingErrorHandler from './error-handler';
import { AvailablePage } from '../../interfaces/connected-page';

const ONBOARDING_STATE = 'ONBOARDING_STATE';

export const SET_JUST_COMPLETED_ONBOARDING = `${ONBOARDING_STATE}__SET_JUST_COMPLETED_ONBOARDING`;
export const SET_AUDIENCE_EXTRACTOR_CHANNEL = `${ONBOARDING_STATE}__SET_AUDIENCE_EXTRACTOR_CHANNEL`;

export type SetJustCompletedOnboarding = ReturnType<
  typeof setJustCompletedOnboarding
>;
export type SetAudienceExtractorChannel = ReturnType<
  typeof setAudienceExtractorChannel
>;

const setJustCompletedOnboarding = (justCompletedOnboarding: boolean) => ({
  type: SET_JUST_COMPLETED_ONBOARDING,
  justCompletedOnboarding,
});

const setAudienceExtractorChannel = (
  audienceExtractorChannel: 'instagram' | 'facebook',
) => ({
  type: SET_AUDIENCE_EXTRACTOR_CHANNEL,
  audienceExtractorChannel,
});

const connectPage =
  (
    companyId: number,
    pageInfo: AvailablePage,
    onboarding?: boolean,
    templateBotId?: number,
  ) =>
  async (dispatch: Dispatch<StoreState>) => {
    try {
      const { facebookPage, bot } =
        await ConnectedPageController.postConnectedPage(
          pageInfo,
          companyId,
          undefined,
          !!onboarding,
          templateBotId,
        );

      return { facebookPage, bot };
    } catch (error) {
      onboardingErrorHandler(dispatch)(
        error,
        'Onboarding add page to backend error',
      );
    }
  };

const onboardingActions = {
  connectPage,
  setJustCompletedOnboarding,
  setAudienceExtractorChannel,
};

export default onboardingActions;
